export default "__VITE_ASSET__CZrUWnPa__"